module.exports = __webpack_public_path__ + "static/media/team2.440ca149.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/about-company/img/team2.jpg
// module id = 1725
// module chunks = 147